export function formatFaNumber(num) {
  return new Intl.NumberFormat('fa-IR').format(num)
}

export function formatFaPrice(price, currency = '') {
  const formatted = formatFaNumber(price || 0)
  return currency ? `${formatted} ${currency}` : formatted
}